import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const clientPaymentPlan = props.clientPaymentPlan;
  const setEditMode = props.setEditMode;

  // Format hourlyRate to two decimal places if it exists and is a number
  const formattedHourlyRate =
    clientPaymentPlan?.hourlyRate != null && !isNaN(Number(clientPaymentPlan.hourlyRate)) ?
      Number(clientPaymentPlan.hourlyRate).toFixed(2) :
      clientPaymentPlan?.hourlyRate;

  return (
    <Stack
      direction={'column'}
      sx={{
        'display': 'flex',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={setEditMode}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression={'client.ClientDetail.Payment.PaymentPlan.HourlyRateTitle'}
          />
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '18px',
          }}
        >
          {clientPaymentPlan?.hourlyRate ?
            <Translate
              expression='client.ClientDetail.Payment.PaymentPlan.HourlyCost'
              substitute={{hourlyRate: formattedHourlyRate}}
            /> :
            <Translate
              expression='client.ClientDetail.Payment.PaymentPlan.NoHourlyRate'
            />
          }
        </Typography>
      </Box>
    </Stack>
  );
};

Content.propTypes = {
  clientPaymentPlan: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
